module.exports = __webpack_public_path__ + "assets/images/template/timeline.png?v=5c13ec12";